import { Loading } from '@/components/shared';
import { memo, useMemo, lazy, Suspense } from 'react';
import { ServerStatusProvider } from '@/context/ServerStatus';
import { useSelector } from 'react-redux';
import useDirection from '@/utils/hooks/useDirection';
import useLocale from '@/utils/hooks/useLocale';
import { themeConfig } from '@/configs/theme.config';

const loaders = {
	'classic': () => import('./ClassicLayout'),
	'modern': () => import('./ModernLayout'),
	'stackedSide': () => import('./StackedSideLayout'),
	'simple': () => import('./SimpleLayout'),
	'decked': () => import('./DeckedLayout'),
	'blank': () => import('./BlankLayout'),
}

const layouts = Object.fromEntries(Object.entries(loaders).map(([type, load]) => [type, lazy(load)]));

loaders[themeConfig.layout.type]?.();

const Layout = () => {
	const layoutType = useSelector((state) => state.theme.layout.type);


	useDirection();
	useLocale();


	const AppLayout = useMemo(() => layouts[layoutType], [layoutType]);

	return (<Suspense fallback={<div className="flex flex-auto flex-col h-[100vh]">
		<Loading loading={true} />
	</div>}	>
		<ServerStatusProvider>
			<AppLayout />
		</ServerStatusProvider>
	</Suspense>);
}

export default memo(Layout);